import React, { useMemo } from 'react';
import { useSelector } from 'umi';
import { genWatermarkDataUrl } from '@home/utils/watermark';
import './index.scss';

interface IMaskProps {
  /** 自定义水印文字颜色 */
  color?: string;
}

/**
 * 全局页面水印遮罩
 * 水印图案生成见 `@home/utils/watermark`（与导出共用）
 */
export default function Mask(props: IMaskProps) {
  const { color } = props;
  // 可选链避免 home model 未就绪时解构抛错导致白屏
  const userInfo = useSelector((state: any) => state?.home?.userInfo);

  const img = useMemo(() => {
    if (!userInfo) {
      return null;
    }

    const loginCode = userInfo?.code ? `${userInfo.code}` : '';
    const userId = userInfo?.openid || userInfo?.userid || '';

    return genWatermarkDataUrl({
      text: `${userId}@DataBrain`,
      loginCode,
      color,
    });
  }, [userInfo, color]);

  if (!img) {
    return null;
  }

  return (
    <div className="dbh-mask-wrap">
      <div className="dbh-mask-bg" style={{ backgroundImage: `url(${img})` }} />
    </div>
  );
}
